import { combineReducers } from "@reduxjs/toolkit";
import { reportCommentsReducer } from "./reportComments/reducer";
import resultsReducer from "./results/resultsSlice";

const createRootReducer = () =>
	combineReducers({
		results: resultsReducer,
		reportComments: reportCommentsReducer,
	});

export type ApplicationState = ReturnType<ReturnType<typeof createRootReducer>>;
export default createRootReducer;
